import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store';
import { message, notification } from 'ant-design-vue';

Vue.use(VueRouter);

// 复写warn方法方便检查由于使用name跳转无法监控404的问题
const sourceWarn = window.console.warn;
window.console.warn = function(...rest) {
  const args = Array.from(rest);
  if (args[0] && args[0].includes('Route with name') && args[0].includes('does not exist')) {
    // 如果路由不存在，跳转回404
    setTimeout(() => {
      router.push({ name: 'notFound' });
    }, 0);
  }
  sourceWarn(...rest);
};

// 解决报错： vue-router.esm.js?8c4f:1958 Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location: "/login".
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // loading
  store.commit('setPageLoading', to.meta && to.meta.pageloading !== false);

  // 进入新页面时，清除提示
  notification.destroy();
  message.destroy();

  // 路由变化时，清空轮询
  store.commit('stopPollingTimer');

  // 看是否有权限
  let hasMatchAuth = true;
  if (
    store.state.authList &&
    store.state.authList.length &&
    to.meta &&
    to.meta.authKey &&
    Array.isArray(to.meta.authKey)
  ) {
    if (to.meta.authKey.length) {
      to.meta.authKey.every(key => {
        // 只要有一个不符合，返回false
        if (!(store.state.authList || []).includes(key)) {
          hasMatchAuth = false;
          return false;
        }
        return true;
      });
    }
  }
  if (hasMatchAuth) {
    // 有权限
    next();
  } else {
    store.commit('setPageLoading', false);
    // 判断首页是否有权限，如果没有权限，跳转欢迎页面
    if (
      to.name === 'Home' &&
      !(store.state.authList && store.state.authList.includes('auth_home'))
    ) {
      next('/manage/welcome');
    } else {
      // 无权限，全部跳转到无权限
      next('/manage/noauth');
    }
  }
});

// router.afterEach((to, from) => {
router.afterEach(to => {
  // autoCollect为false时，表示历史记录不自动收集（或在页面内手动收集
  if (
    to.meta &&
    to.meta.autoCollect !== false &&
    // 已经包含时不收集（确保一个路由只收集一次，有的路由会有参数，会收集多个，需要根据参数收集，请在页面中手动收集，例如设备的详情页面）
    !store.state.historyRouteListNames.includes(to.name)
  ) {
    // 收集访问历史记录
    store.commit('setHistoryRouteList', to);
  } else {
    // 当页面刷新时
    if (!store.state.historyRouteListNames.length) {
      store.commit('setHistoryRouteList', null);
    }
  }

  // 滚动条恢复到最顶端
  document.body.scrollTop = 0;
  const layoutContent = document.getElementById('layoutContent');
  if (layoutContent) {
    layoutContent.scrollTop = 0;
  }
  store.commit('setBreadcrumb', to);
});

export default router;
